export const ShiftStatusConst = {
  AVAILABLE: 'available',
  ASSIGNED: 'assigned',
  COMPLETED: 'completed',
  INCOMPLETE: 'incomplete',
  CANCELLED: 'cancelled',
  IN_PROGRESS: 'in_progress',
  OFFERED: 'offered',
  NO_SHOW: 'no_show',
} as const;

export type ShiftStatusConst =
  (typeof ShiftStatusConst)[keyof typeof ShiftStatusConst];
